import { EnumRole } from '@types';
import { getStorageItem } from 'helpers';

export const generateRedirectPathIsAuth = () => {
    const userRole = getStorageItem('ROLE') as EnumRole;

    if (userRole === EnumRole.OWNER) {
        return `/admin`;
    }

    return '/';
};
